import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";

function ImageUploader() {
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  const handleUpload = () => {
    if (!file) return;

    const fileRef = ref(storage, file.name);

    uploadBytes(fileRef, file).then(() => {
      getDownloadURL(fileRef).then((url) => {
        console.log("URL immagine:", url);
        setImageUrl(url); // ✅ Salva l'URL per visualizzarlo
      });
    });
  };

  return (
    <div>
      <input type="file" onChange={(e) => setFile(e.target.files[0])} />
      <button onClick={handleUpload}>Carica immagine</button>

      {imageUrl && <img src={imageUrl} alt="Immagine caricata" />}
    </div>
  );
}

export default ImageUploader;
